var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"conversation_header"},[_c('TheHeaderVue',{attrs:{"color":_vm.black}})],1),_c('SectionConversation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }